import { useAtsEmployerApi, useFFRestApi } from '@/composables/useApi';
import type { Employer } from '@factoryfixinc/ats-interfaces';
import { InternalError } from '../errors/internal.error';
import type { EmployerPolicy } from '@factoryfixinc/ats-interfaces';

export class EmployerPersistence {
  public async fetchPolicies(employerId: Employer['id']): Promise<EmployerPolicy[]> {
    const url = `/employer/${employerId}/policies`;
    const { data, error, statusCode } = await useAtsEmployerApi<EmployerPolicy[]>(url).json();

    if (error.value) {
      throw new InternalError('Failed to fetch employer policies', {
        error: error.value,
        status: statusCode.value,
        data: { employerId },
      });
    }

    return data.value ?? [];
  }

  public async updateEmployer(
    employerId: Employer['id'],
    employerUpdate: Partial<Employer>,
  ): Promise<void> {
    const url = `/employer/${employerId}`;
    const { error, statusCode } = await useFFRestApi(url).patch(employerUpdate);

    if (error?.value) {
      throw new InternalError('Failed to update employer data', {
        error: error.value,
        status: statusCode.value,
        data: { employerId },
      });
    }
  }

  public async updatePolicies(
    employerId: Employer['id'],
    policies: Pick<EmployerPolicy, 'name' | 'policy'>[],
  ): Promise<void> {
    const url = `/employer/${employerId}/policies`;
    const { error, statusCode } = await useAtsEmployerApi(url).post(policies, 'json');

    if (error.value) {
      throw new InternalError('Failed to update employer policies', {
        error: error.value,
        status: statusCode.value,
        data: { employerId, policies },
      });
    }
  }
}
